import { Box, Button, Flex } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { NavLink } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SubmenuHeader from './SubmenuHeader';

interface DashboardProps {
  children: ReactNode;
}

interface DashboardSubComponentProps {
  children: ReactNode;
}

export const IconLink = ({
  children,
  href,
  icon
}: {
  icon?: IconProp;
  href: string;
  children: ReactNode;
}) => {
  return (
    <NavLink
      style={{ justifyContent: 'flex-start' }}
      to={href}
      tabIndex={-1}
      end
    >
      {({ isActive }) => (
        <Button
          borderColor="white"
          borderRadius={0}
          color={isActive ? 'actionPrimaryFill' : 'none'}
          background={isActive ? 'gray.100' : 'white'}
          borderBottom={isActive ? '2px solid' : 'none'}
        >
          {icon && (
            <Flex width={4} justifyContent="center" alignItems="center">
              <FontAwesomeIcon icon={icon} />
            </Flex>
          )}
          {children}
        </Button>
      )}
    </NavLink>
  );
};

const Dashboard: React.FC<DashboardProps> & {
  MainArea: React.FC<DashboardSubComponentProps>;
} = ({ children }) => {

  return (
    <>
      <SubmenuHeader />

      <Flex
        height='calc(100vh - 110px)'
        overflowY="hidden"
      >
        {children}
      </Flex>
    </>
  );
};

Dashboard.MainArea = ({ children }: DashboardSubComponentProps) => {
  return (
    <Box
      width="100%"
      height="100%"
      overflowY="auto"
      backgroundColor="surfaceSecondaryFill"
      minWidth={0}
    >
      {children}
    </Box>
  );
};


export default Dashboard;
